<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <v-icon>mdi-message-processing-outline</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex">
            <span class="font-weight-bold">{{ messageTemplate.subject }}</span>
          </div>
          <div class="status-wrapper">
            <span class="mr-1 mt-1 secondary-text">{{
              messageTemplate.formattedTags
            }}</span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
export default {
  name: "MessageTemplateItem",
  props: {
    messageTemplate: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scope></style>
